import { createApi } from '@reduxjs/toolkit/query/react';
import { dynamicBaseQuery } from './utils';

export enum API_KEYS {
  CHARGERS = 'chargers',
  SESSIONS = 'sessions',
  LOCATION = 'locations',
  LOCATIONV3 = 'locationsV3',
  USERGROUPS = 'usergroups',
  INVITES = 'invites',
  PRICE_MODELS = 'pricemodels',
  NOTIFICATIONS = 'notifications',
  DELEGATION_INVITES = 'delegationinvites',
  CARDS = 'cards',
  VEHICLES = 'vehicles',
  WHITELABELS = 'whitelabels',
  DISCOUNT = 'priceadjustments',
  CHARGERS_BY_BATCH = 'chargers-by-batch',
  USERS = 'users',
  CHARGER_DETAIL = 'chargerdetails',
  PROVISION = 'provision',
  COMPANIES = 'companies',
  GOOGLE_ANALYTICS = 'mp/collect',
  HISTORICAL = 'historical',
  MESSAGE = 'messages',
  CIRCUITS = 'Circuits',
  PAYMENT_TERMINALS = 'paymentterminals',
  PAYMENT_TERMINALS_COMBINED = 'combinedpaymentterminals',
  PERSONALIZATION = 'personalization',
  SUPPORT_NOTE = 'supportnote',
  LICENSE = 'licenses',
  LICENSE_AUDIT_HISTORY = 'audit-history',
  LICENSE_SELF_SERVE = 'self-serve',
  RENEWABLE = 'renewable',
  RENEWAL = 'renewal',
  FEE_PACKAGES = 'feePackages',
  PAYOUTS = 'payouts',
  STATEMENT = 'statement',

  // Only used as a tag for personal invites while we migrate
  PERSONAL_INVITES = 'personal-invites',
  HUBSPOT = 'hubspot',
  PRICE_RULE_GUARDRAILS = 'priceRuleGuardrails',
  CHARGER_MODELS = 'chargerModels',
  CHARGER_MODEL_DEPLOYMENT = 'chargerModelDeployment',
  LICENSE_ALIGNMENT = 'license-alignment',

  PROMOTIONS = 'promotions',
  PROMO_CODES = 'promo-codes',
}

export const Api = createApi({
  baseQuery: dynamicBaseQuery,
  endpoints: () => ({}),
  reducerPath: 'base',
  // keepUnusedDataFor: 10,
  // refetchOnMountOrArgChange: true,
}).enhanceEndpoints({
  // Please remember add you endpoint key here as a tag
  addTagTypes: Object.values(API_KEYS),
});
